var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
		_vm.$store.state.currentPage &&
		(_vm.$store.state.currentPage.created ||
			_vm.$store.state.currentPage.updated)
	)?_c('CrawlerOnly',[(
			_vm.$store.state.currentPage.lang &&
			['en-US', 'en-GB'].includes(_vm.$store.state.currentPage.lang)
		)?[_c('span',[_vm._v("\n\t\t\tPage created\n\t\t\t"),(_vm.$store.state.currentPage.created)?_c('time',{attrs:{"datetime":_vm.$store.state.currentPage.created},domProps:{"textContent":_vm._s(
					new Date(
						_vm.$store.state.currentPage.created
					).toLocaleDateString(_vm.$store.state.currentPage.lang, {
						weekday: 'long',
						year: 'numeric',
						month: 'long',
						day: 'numeric',
					})
				)}}):_vm._e()]),_vm._v(" "),_c('span',[_vm._v("\n\t\t\tPage updated\n\t\t\t"),(_vm.$store.state.currentPage.updated)?_c('time',{attrs:{"datetime":_vm.$store.state.currentPage.updated},domProps:{"textContent":_vm._s(
					new Date(
						_vm.$store.state.currentPage.updated
					).toLocaleDateString(_vm.$store.state.currentPage.lang, {
						weekday: 'long',
						year: 'numeric',
						month: 'long',
						day: 'numeric',
					})
				)}}):_vm._e()])]:[_c('span',[_vm._v("\n\t\t\tSiden er oprettet\n\t\t\t"),(_vm.$store.state.currentPage.created)?_c('time',{attrs:{"datetime":_vm.$store.state.currentPage.created},domProps:{"textContent":_vm._s(
					new Date(
						_vm.$store.state.currentPage.created
					).toLocaleDateString(_vm.$store.state.currentPage.lang, {
						weekday: 'long',
						year: 'numeric',
						month: 'long',
						day: 'numeric',
					})
				)}}):_vm._e()]),_vm._v(" "),_c('span',[_vm._v("\n\t\t\tSiden er redigeret\n\t\t\t"),(_vm.$store.state.currentPage.updated)?_c('time',{attrs:{"datetime":_vm.$store.state.currentPage.updated},domProps:{"textContent":_vm._s(
					new Date(
						_vm.$store.state.currentPage.updated
					).toLocaleDateString(_vm.$store.state.currentPage.lang, {
						weekday: 'long',
						year: 'numeric',
						month: 'long',
						day: 'numeric',
					})
				)}}):_vm._e()])]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }